import React, { useState } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import logo from './logo.png';
import VisitorForm from './VisitorForm';
import NewForm from './NewForm';
import Renewal from './Renewal';
import NomineeAdd from './NomineeAdd';
import Claim from './Claim';
import Appointment from './Appointment';
import PeriodicalReport from './PeriodicalReport';

function Home({ user, onLogout }) {
  const [active, setActive] = useState('New Form');

  return (
    <Box sx={{ minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif", background: '#f5f7fb', width: '100%' }}>
      <Box sx={{ width: '100%', maxWidth: '100%', mx: 0, px: 0, py: { xs: 1, sm: 2 }, boxSizing: 'border-box' }}>
        <Paper sx={{ display: 'flex', gap: 2, alignItems: 'center', p: 2, mb: 2 }} elevation={3}>
          {/* <Box component="img" src={logo} alt="Logo" sx={{ width: 72 }} /> */}
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h5" sx={{ color: '#0b4a6f', fontWeight: 700 }}>WorkersOrg Visitor Management</Typography>
            <Typography variant="body2" sx={{ color: '#556', mt: 0.5 }}>Capture visitor details quickly</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#333' }}>
              Welcome, {user?.namename || 'User'} ({user?.user_role})
            </Typography>
            <Button variant="outlined" color="error" onClick={onLogout}>Logout</Button>
          </Box>
        </Paper>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', backgroundColor: '#E65100' }}>
          {/* <Button onClick={() => setActive('Visitor Form')} sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}>Visitor Form</Button> */}
          <Button onClick={() => setActive('New Form')} sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}>New Form</Button>
          <Button onClick={() => setActive('Renew')} sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}>Renew</Button>
          <Button onClick={() => setActive('Claim')} sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}>Claim</Button>
          <Button onClick={() => setActive('Add Nominee')} sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}>Add Nominee</Button>
          <Button onClick={() => setActive('Appointment')} sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}>Appointment</Button>
          <Button onClick={() => setActive('Periodical Report')} sx={{ color: '#fff', fontWeight: 600, p: 1.5, borderLeft: '1px solid rgba(255,255,255,0.3)' }}>Periodical Report</Button>
        </Box>

        <Box sx={{ mt: 2 }}>
          {active === 'Visitor Form' ? (
            <VisitorForm userid={user?.userid} />
          ) : active === 'New Form' ? (
            <NewForm userid={user?.userid} user={user} />
          ) : active === 'Renew' ? (
            <Renewal userid={user?.userid} user={user} />
          ) : active === 'Claim' ? (
            <Claim userid={user?.userid} user={user} />
          ) : active === 'Add Nominee' ? (
            <NomineeAdd userid={user?.userid} user={user} />
          ) : active === 'Appointment' ? (
            <Appointment userid={user?.userid} user={user} />
          ) : active === 'Periodical Report' ? (
            <PeriodicalReport />
          ) : (
            <Paper sx={{ p: 4 }}>
              <Typography variant="h6">{active}</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>This section is reserved for the "{active}" feature.</Typography>
            </Paper>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default Home;
